<template>
  <the-news :data="news" @change="handleChange" />
</template>

<script>
import TheNews from '@/components/TheNews'

const NEWS_LIST_API = '/wbhome/newsList'

export default {
  components: { TheNews },
  async asyncData({ app, $winstonLog }) {
    // 获取极致资讯首页数据
    try {
      const news = await app.$axios.get(NEWS_LIST_API, { params: { page: 1 } })
      return { news: (news.data && news.data.data) || {} }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return { news: {} }
    }
  },
  methods: {
    async handleChange(page) {
      // 获取极致资讯指定页数据
      const { data } = await this.$axios.get(NEWS_LIST_API, {
        params: { page },
      })
      this.news = data.data || {}
    },
  },
}
</script>
